import { render } from "./Coordination.vue?vue&type=template&id=185049c4&scoped=true"
import script from "./Coordination.vue?vue&type=script&lang=js"
export * from "./Coordination.vue?vue&type=script&lang=js"

import "./Coordination.vue?vue&type=style&index=0&id=185049c4&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185049c4"]])

export default __exports__